/*
 * Created Date: 14-01-2023, 10:37:27 pm
 * Author: Hai Tran
 * Email: you@you.you
 * -----
 * Last Modified:
 * Modified By:
 * -----
 * Copyright (c) 2023 PT CORP, Inc
 * -----
 * HISTORY:
 * Date      	By	Comments
 * ----------	---	----------------------------------------------------------
 */

import React, { useCallback, useMemo } from 'react'
import { levelSchoolService } from '@App/Studio/services/levelSchoolService'
import { errorMsg } from '@Core/Helpers/Message'
import { CoreAutocomplete } from '@Core/Components/Input'
import { useRequest } from 'ahooks'
import { addCacheMasterData } from '@Core/Helpers/Cache'
import { getSystemSettingSession } from '@Core/Helpers/Session'
import { useCoreAppContext } from '@Core/Provider/CoreAppProvider'
import { get } from 'lodash'
// import PropTypes from 'prop-types'

const SelectLevelSchool = props => {
	const { control, name, ...restProps } = props
	const { systemConfig } = useCoreAppContext()
	// const fetchLevelSchool = useCallback(async () => {
	// 	try {
	// 		const res = await levelSchoolService.listWithOptions({ size: 1000 })
	// 		return res
	// 	} catch (error) {
	// 		errorMsg(error)
	// 	}
	// }, [])

	// const { data, loading } = useRequest(fetchLevelSchool, {
	// 	cacheKey: `select-level-school`,
	// 	cacheTime: 60 * 60 * 1000,
	// 	staleTime: 60 * 60 * 1000,
	// 	onSuccess: res => {
	// 		addCacheMasterData('levelSchool', 'select-level-school')
	// 	}
	// 	// refreshDeps: [JSON.stringify(query)]
	// })

	const data = useMemo(() => {
		return get(systemConfig, 'level_schools', [])
	}, [systemConfig])
	// console.log('============= data', data)
	return (
		<CoreAutocomplete
			control={control}
			name={name}
			// fetchOptions={fetchLevelSchool}
			options={data}
			// loading={loading}
			valuePath="id"
			labelPath="name"
			{...restProps}
		/>
	)
}

// SelectLevelSchool.defaultProps = {}

// SelectLevelSchool.propTypes = {}

export default React.memo(SelectLevelSchool)
